import TeamDetailMember from '@/screens/TeamDetailMember';

export default function PrivateTabsChatTeamTeamIdIndexRoute() {
  return <TeamDetailMember memberPathname="/chat/team/member/[personId]" />;
}
